import * as React from "react";

import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import RootRef from "@material-ui/core/RootRef";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "@material-ui/styles/styled";

import Brush from "@material-ui/icons/Brush";
import Category from "@material-ui/icons/Category";
import SignalCellular3Bar from "@material-ui/icons/SignalCellular3Bar";
import Star from "@material-ui/icons/Star";

import grey from "@material-ui/core/colors/grey";
import lightBlue from "@material-ui/core/colors/lightBlue";

interface ClipboardItem {
  readonly types: string[];
  readonly presentationStyle: "unspecified" | "inline" | "attachment";
  getType(): Promise<Blob>;
}

interface ClipboardItemData {
  [mimeType: string]: Blob | string | Promise<Blob | string>;
}

declare var ClipboardItem: {
  prototype: ClipboardItem;
  new (itemData: ClipboardItemData): ClipboardItem;
};

export interface Props {
  author?: string;
  title: string;
  score: string;
  sales: string;
  rating: string;
  genreFit: string;
  styleFit: string;
  disableCopy?: boolean;
}

const RadialPaper = styled(Paper)({
  borderRadius: "50%",
  display: "inline-block",
  position: "absolute",
  bottom: 0,
  right: 0,
  padding: 20,
  backgroundColor: grey[200],
  width: 72,
  height: 72,
  textAlign: "center",
});

export const BusinessCard = (props: Props) => {
  const { author, title, score, sales, rating, genreFit, styleFit } = props;

  const boxRef = React.useRef<HTMLElement>();

  return (
    <Box>
      <RootRef rootRef={boxRef}>
        <Box position="relative" width={480} height={112}>
          <Box position="absolute" bottom={54} left={0} right={110}>
            <Typography variant="h6" color="textPrimary" noWrap={true}>
              {title} {author && <>({author})</>}
            </Typography>
          </Box>
          <Box
            position="absolute"
            bottom={0}
            right={48}
            left={0}
            borderRadius={4}
            pt={1}
            px={1.5}
            bgcolor={lightBlue[600]}
            color="white"
          >
            <Typography variant="body1">
              <Box display="flex" justify-content="space-between">
                <Tooltip title="Sales Potential">
                  <Box flexBasis="30%">
                    <SignalCellular3Bar fontSize="inherit" />
                    {sales}
                  </Box>
                </Tooltip>
                <Tooltip title="Predicted Rating">
                  <Box flexBasis="20%">
                    <Star fontSize="inherit" /> {rating}
                  </Box>
                </Tooltip>
                <Tooltip title="Genre Fit">
                  <Box flexBasis="20%">
                    <Category fontSize="inherit" /> {genreFit}
                  </Box>
                </Tooltip>
                <Tooltip title="Style Fit">
                  <Box flexBasis="30%">
                    <Brush fontSize="inherit" /> {styleFit}
                  </Box>
                </Tooltip>
              </Box>
            </Typography>
            <Typography variant="caption">
              Assessment by{" "}
              <b>
                <i>Iris</i>
              </b>{" "}
              - click for more info
            </Typography>
          </Box>
          <RadialPaper elevation={0}>
            <Tooltip title="Manuscript Score">
              <Typography variant="h2">{score}</Typography>
            </Tooltip>
          </RadialPaper>
        </Box>
      </RootRef>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/BusinessCard/BusinessCard.tsx